module.exports = __webpack_public_path__ + "static/media/bronze_link_banner_zh.96d5cf2e.png";